// AI Forms admin API (webd /aiform, the V2 /v1/forms shapes). Every call
// returns a native Promise; a failure rejects with {status, body, message}
// so definition.problemsFrom() can read 422 `errors`.

import $ from 'jquery';
import { CheckEndpoint } from '../../../redux/actions/async/restful';
import { AIFormAreas, AIFormForms, AIFormHosted } from '../../../redux/constants/endpoints';
import { I } from '../../../common/v5/config';

function errorFrom(xhr) {
	const status = xhr ? xhr.status : 0;
	const body = xhr ? xhr.responseText || "" : "";
	let message = I("Something went wrong.");
	if (status === 0) {
		message = I("The server could not be reached.");
	} else if (status === 401 || status === 403) {
		message = I("You don't have access to AI forms.");
	} else if (status === 404) {
		message = I("Not found.");
	} else if (xhr && xhr.statusText) {
		message = xhr.statusText;
	}
	return { status, body, message };
}

function call(method, path, data) {
	const opts = {
		url: CheckEndpoint(path),
		method,
		dataType: "json",
		cache: false,
	};
	if (data !== undefined) {
		opts.data = JSON.stringify(data);
		opts.contentType = "application/json";
	}
	return new Promise((resolve, reject) => {
		$.ajax(opts)
			.done((res, _text, xhr) => resolve(xhr && xhr.status === 204 ? null : res))
			.fail((xhr) => {
				// DELETE answers 204 with no body; jQuery calls that a parse error.
				if (xhr && xhr.status >= 200 && xhr.status < 300) {
					resolve(null);
					return;
				}
				reject(errorFrom(xhr));
			});
	});
}

const one = id => AIFormForms + "/" + encodeURIComponent(id);

export const listForms = () => call("GET", AIFormForms).then(r => (r && r.items) || []);
export const createForm = (input) => call("POST", AIFormForms, input);
export const getForm = id => call("GET", one(id));
export const updateForm = (id, input) => call("PATCH", one(id), input);
export const publishForm = id => call("POST", one(id) + "/publish", {});
export const unpublishForm = id => call("POST", one(id) + "/unpublish", {});
export const rotateKey = id => call("POST", one(id) + "/rotate-key", {});
export const deleteForm = id => call("DELETE", one(id));
export const getEmbed = id => call("GET", one(id) + "/embed");
export const previewToken = id => call("POST", one(id) + "/preview-token", {});
export const listAreas = () => call("GET", AIFormAreas).then(r =>
	((r && r.items) || []).map(a => ({ id: String(a.id), name: a.name })));

// The hosted page when the embed codes are not loaded yet (same origin as webd).
export const hostedLink = key => CheckEndpoint(AIFormHosted + "/" + encodeURIComponent(key));
